var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgYoutube(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Icon_awesome-youtube",
    "data-name": "Icon awesome-youtube",
    xmlns: "http://www.w3.org/2000/svg",
    width: 22.756,
    height: 16,
    viewBox: "0 0 22.756 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-youtube-2",
    "data-name": "Icon awesome-youtube",
    d: "M23.33,7a2.859,2.859,0,0,0-2.012-2.025c-1.775-.479-8.89-.479-8.89-.479s-7.116,0-8.89.479A2.859,2.859,0,0,0,1.525,7a30,30,0,0,0-.475,5.513,30,30,0,0,0,.475,5.513,2.817,2.817,0,0,0,2.012,1.993c1.775.479,8.89.479,8.89.479s7.116,0,8.89-.479a2.817,2.817,0,0,0,2.012-1.993,30,30,0,0,0,.476-5.513A30,30,0,0,0,23.33,7ZM10.1,15.9V9.133l5.947,3.384L10.1,15.9Z",
    transform: "translate(-1.05 -4.5)",
    fill: "#3787c9"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/youtube.adc838b0c6389dc31b0fc223cefbe933.svg";
export { ForwardRef as ReactComponent };